import {
  DISTANCE_UNIT_LABEL_KEY,
  DISTANCE_UNIT_RATE_LABEL_KEY,
} from "@nmible-ltd/claims";
import { Coins, Route } from "lucide-react";
import { useTranslation } from "react-i18next";

import { InfoItem } from "@/components/info-item";

import type { MileageDetails } from "../types";

interface PanelMileageProps {
  details: MileageDetails;
}

export const PanelMileage = ({ details }: PanelMileageProps) => {
  const { t } = useTranslation();

  return (
    <>
      <InfoItem
        icon={<Route size={18} />}
        label={t("distance")}
        value={
          <span className="font-mono">
            {details.distance} {t(DISTANCE_UNIT_LABEL_KEY[details.unit])}
          </span>
        }
      />
      <InfoItem
        icon={<Coins size={18} />}
        label={t(DISTANCE_UNIT_RATE_LABEL_KEY[details.unit])}
        value={<span className="font-mono">{details.ratePerUnit}</span>}
      />
    </>
  );
};
